const mendata=[
{
    id:1,
    category:"Jeans",
    img:"https://media.istockphoto.com/id/527236518/photo/mans-legs.jpg?s=612x612&w=0&k=20&c=lczyG0ZkWelpn_o-I_VpjAMo_sA3WpdWHMlgZjCSE-k=",
    price:80
   
},


{
    id:2,
    category:"Tshirt",
    img:"https://media.istockphoto.com/id/1378996666/photo/portrait-of-friendly-young-man.jpg?s=612x612&w=0&k=20&c=bwaEnB9zcLV1THlgW3sQ1xHFKNdcVqk-FsR8SMZ_GLI=",
   price:70.85
},
{
    id:3,
    category:"Jeans",
   img:"https://thumbs.dreamstime.com/b/blue-mens-jeans-denim-pants-orange-background-contrast-satur-saturated-color-fashion-clothing-concept-view-above-109378110.jpg",
   price:99.89
},
{
    id:4,
    category:"Tshirt",
   img:"https://d1xv5jidmf7h0f.cloudfront.net/circleone/images/products_gallery_images/Custom-Printed-T-Shirt-Round-Neck.jpg",
   price:70.41
},
{
    id:5,
    category:"Jeans",
   img:"https://www.realmenrealstyle.com/wp-content/uploads/2023/07/How-To-Find-A-Pair-Of-Jeans-That-Fit-Just-Right.jpg",
   price:"60.99"
},
{
    id:6,
    category:"Jacket",
   img:"https://img.freepik.com/premium-photo/mens-black-leather-jacket-outdoor-shoot-wall-background_594408-1575.jpg?w=826",
   price:90.89
},
{
id:7,
category:"Tshirt",
img:"https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg",
price:70.99
},
{
    id:8,
    category:"Jacket",
   img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_SGlmwzxxPAmp5eoJRZq9J_FTkscM1xZNQ&s",
   price:80.77
}
]
export default mendata